import { Navigate, Route, Routes } from "react-router-dom";
import { useAuth } from "./auth";
import { Shell } from "./components/Shell";
import { Centred } from "./components/States";
import SignIn from "./pages/SignIn";
import NotACoach from "./pages/NotACoach";
import Dashboard from "./pages/Dashboard";
import Inbox from "./pages/Inbox";
import Review from "./pages/Review";
import Profile from "./pages/Profile";

export default function App() {
    const auth = useAuth();
    if (auth.kind === "loading") return <Centred spinner>Signing you in</Centred>;
    if (auth.kind === "signed_out") return <SignIn />;
    if (auth.kind === "not_a_coach") return <NotACoach user={auth.user} />;
    return (
        <Shell>
            <Routes>
                <Route path="/" element={<Dashboard />} />
                <Route path="/inbox" element={<Inbox />} />
                <Route path="/review/:id" element={<Review />} />
                <Route path="/profile" element={<Profile />} />
                <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
        </Shell>
    );
}
